<template>
  <router-link :to="`/brands/${vanityUrl}`" class="flex align-center">
    <img :src="brandImageUrl" class="brand-cover" />
    <div class="flex-grow right-side">
      <h2 class="font-size-24">{{ brandName }}</h2>
      <div class="mov-value">${{ minimumReorderValue }} reorder minimum</div>
      <bulletin-button
        :variant="isBrandFavorite ? 'selectedActionChip' : 'primary'"
        no-min-width
        small-padding
        class="follow-btn desktop"
        @click="handleFollowClick"
        >{{ isBrandFavorite ? "Following" : "Follow" }}</bulletin-button
      >
    </div>
    <bulletin-button
      :variant="isBrandFavorite ? 'selectedActionChip' : 'primary'"
      no-min-width
      small-padding
      class="follow-btn mobile"
      @click="handleFollowClick"
      >{{ isBrandFavorite ? "Following" : "Follow" }}</bulletin-button
    >
  </router-link>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

h2 {
  @include respond-to("small") {
    line-height: unset;
  }
}

.brand-cover {
  width: 91px;
  height: 112px;
  object-fit: cover;
  border: 1px solid #000000;
  border-radius: 100px;

  @include respond-to("small") {
    width: 48px;
    height: 59px;
  }
}

.right-side {
  margin-left: 24px;

  .mov-value {
    font-size: 12px;
    color: $secondaryGrey4;
    margin-bottom: 8px;
    font-family: NHaasGroteskDSPro-55Rg;
  }
}

.follow-btn {
  padding-inline: 16px !important;
  height: 32px !important;
  /*line-height: 32px !important;*/
  &.desktop {
    @include respond-to("small") {
      display: none;
    }
  }

  &.mobile {
    display: none;
    @include respond-to("small") {
      display: block;
    }
  }
}
</style>

<script>
import FavoriteApi from "../../../services/api/favoritesApi";

const FavoriteApiService = new FavoriteApi();
export default {
  props: {
    brandId: {
      type: String,
    },
    vanityUrl: {
      type: String,
    },
    brandImageUrl: {
      type: String,
    },
    brandName: {
      type: String,
    },
    minimumReorderValue: {
      type: Number,
    },
    isBrandFavorite: {
      type: Boolean,
    },
    onFollowClick: {
      type: Function,
      default: () => null,
    },
  },
  methods: {
    handleFollowClick,
  },
};

async function handleFollowClick(event) {
  event.preventDefault();
  await FavoriteApiService.favoriteBrandToggle(this.brandId);
  this.$ma.trackEvent({
    action: "Favorite Brand",
    properties: {
      "Page name": "reorder",
    },
  });

  this.onFollowClick();
}
</script>
